//region :: Imports ::
import MComponent from '../Component';
import {evalulateBool, MBoolean} from './Control';
import {ReactElement, ChangeEvent, HTMLInputTypeAttribute, RefObject, createRef} from 'react';
import {InputText} from 'primereact/inputtext';
import {FieldProps} from 'formik';
import {MNullable, setFieldValue} from '../../Utils';
import {findDOMNode} from 'react-dom';
import {classNames} from 'primereact/utils';

//endregion

/** */
export type MInputValueType = string | number | readonly string[];

/** */
type Props = {
    id: string;
    initialValue?: MInputValueType;
    type?: HTMLInputTypeAttribute;
    maxLength: number;
    placeholderText?: string;
    readonly?: boolean;
    fieldProps?: FieldProps;
    disabled: MBoolean;
    className?: string;
    onChange?: (newValue: MInputValueType) => void;
}

/** */
type State = {
    value: MInputValueType;
}

/** */
class MTextBox extends MComponent<Props, State> {

    private readonly m_inputRef: RefObject<any>;

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.m_inputRef = createRef<any>();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {

        this.setFocus = this.setFocus.bind(this);
        this.input_onChange = this.input_onChange.bind(this);

    }

    /** */
    private initializeState(): void {

        this.state = {value: this.props.initialValue === undefined ? '' : this.props.initialValue};
        setFieldValue(this.props.fieldProps, this.state.value);

    }

    /** */
    private input_onChange(event: ChangeEvent<HTMLInputElement>): void {
        this.setValue(event.target.value);
    }

    /** */
    public setFocus(): void {

        setTimeout(() => {

            const element = findDOMNode(this.m_inputRef.current!) as MNullable<HTMLInputElement>;
            element?.focus();

        }, 200);

    }

    /** */
    public setValue(newValue: MInputValueType): void {

        this.safeSetState((draft: State) => draft.value = newValue);
        setFieldValue(this.props.fieldProps, newValue);
        this.props.onChange?.(newValue);

    }

    /** */
    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

        if(this.props.fieldProps?.field.value !== prevProps.fieldProps?.field.value) {

            this.safeSetState((draft: State) =>
                draft.value = this.props.fieldProps!.field.value);

        }

    }

    /** */
    public render(): ReactElement {

        return (
            <InputText id={this.props.id}
                       type={this.props.type === undefined ? 'text' : this.props.type}
                       maxLength={this.props.maxLength}
                       placeholder={this.props.placeholderText}
                       readOnly={this.props.readonly ?? false}
                       disabled={evalulateBool(this.props.disabled)}
                       className={classNames(this.props.className, {'surface-50': this.props.readonly})}
                       {
                           ...this.props.fieldProps?.field
                       }
                       value={this.state.value}
                       onChange={this.input_onChange}
                       ref={this.m_inputRef}/>
        );

    }

}

export default MTextBox;
